import { AffirmIcon } from './Affirm';
import { AlfaBankIcon } from './AlfaBank';
import { AlipayIcon } from './Alipay';
import { AmazonIcon } from './Amazon';
import { AmericanExpressIcon } from './AmericanExpress';
import { AMEXIcon } from './AMEX';
import { ApplePayIcon } from './ApplePay';
import { BancontactIcon } from './Bancontact';
import { BitcoinIcon } from './Bitcoin';
import { BitcoinCashIcon } from './BitcoinCash';
import { BitpayIcon } from './Bitpay';
import { CitadeleIcon } from './Citadele';
import { DefaultIcon } from './Default';
import { DinersClubIcon } from './DinersClub';
import { DirectDebitIcon } from './DirectDebit';
import { DiscoverIcon } from './Discover';
import { EloIcon } from './Elo';
import { EthereumIcon } from './Ethereum';
import { ForbrugsforeningenIcon } from './Forbrugsforeningen';
import { GiropayIcon } from './giropay';
import { GooglePayIcon } from './GooglePay';
import { IdealIcon } from './Ideal';
import { InteracIcon } from './Interac';
import { JCBIcon } from './JCB';
import { KlarnaIcon } from './Klarna';
import { LightcoinIcon } from './Lightcoin';
import { MaestroIcon } from './Maestro';
import { MastercardIcon } from './Mastercard';
import { PayoneerIcon } from './Payoneer';
import { PaypalIcon } from './Paypal';
import { PaySafeIcon } from './Paysafe';
import { QiwiIcon } from './Qiwi';
import { SberBankIcon } from './SberBank';
import { SEPAIcon } from './SEPA';
import { ShopifyIcon } from './Shopify';
import { ShopPayIcon } from './ShopPay';
import { SkrillIcon } from './Skrill';
import { SofortIcon } from './Sofort';
import { StripeIcon } from './Stripe';
import { SwiftIcon } from './Swift';
import { TinkoffIcon } from './Tinkoff';
import { UnionPayIcon } from './UnionPay';
import { VerifoneIcon } from './Verifone';
import { VisaIcon } from './Visa';
import { WebMoneyIcon } from './WebMoney';
import { WeChatIcon } from './WeChat';
import { WesternUnionIcon } from './WesternUnion';
import { WorldPayIcon } from './WorldPay';
import { YandexIcon } from './Yandex';
import { YandexKassaIcon } from './YandexKassa';

const PaymentIcons = {
  Affirm: AffirmIcon,
  ApplePay: ApplePayIcon,
  Alipay: AlipayIcon,
  Amazon: AmazonIcon,
  AMEX: AMEXIcon,
  Bancontact: BancontactIcon,
  Bitcoin: BitcoinIcon,
  BitcoinCash: BitcoinCashIcon,
  Bitpay: BitpayIcon,
  Discover: DiscoverIcon,
  GooglePay: GooglePayIcon,
  Citadele: CitadeleIcon,
  Default: DefaultIcon,
  DinersClub: DinersClubIcon,
  Paypal: PaypalIcon,
  WesternUnion: WesternUnionIcon,
  Stripe: StripeIcon,
  Mastercard: MastercardIcon,
  Visa: VisaIcon,
  Swift: SwiftIcon,
  AmericanExpress: AmericanExpressIcon,
  WebMoney: WebMoneyIcon,
  JCB: JCBIcon,
  WorldPay: WorldPayIcon,
  SberBank: SberBankIcon,
  DirectDebit: DirectDebitIcon,
  Qiwi: QiwiIcon,
  AlfaBank: AlfaBankIcon,
  Tinkoff: TinkoffIcon,
  YandexKassa: YandexKassaIcon,
  Shopify: ShopifyIcon,
  Elo: EloIcon,
  Ethereum: EthereumIcon,
  Forbrugsforeningen: ForbrugsforeningenIcon,
  Giropay: GiropayIcon,
  Ideal: IdealIcon,
  Interac: InteracIcon,
  Klarna: KlarnaIcon,
  Lightcoin: LightcoinIcon,
  Maestro: MaestroIcon,
  Payoneer: PayoneerIcon,
  SEPA: SEPAIcon,
  PaySafe: PaySafeIcon,
  ShopPay: ShopPayIcon,
  Skrill: SkrillIcon,
  Sofort: SofortIcon,
  UnionPay: UnionPayIcon,
  Verifone: VerifoneIcon,
  WeChat: WeChatIcon,
  Yandex: YandexIcon,
};

export default PaymentIcons;
